export enum TimerType {
    'Decrement',
    'Increment',
    'Total'
}
